<div class="col-12">
  <div *ngIf="inputConfig.control">
    <ng-container>
      <div class="d-flex justify-content-between">
        <ui-fh-label [labelConfig]="labelConfigs"></ui-fh-label>
        <p-inputSwitch
          styleClass="{{ inputConfig.class }}"
          [formControl]="inputConfig.control!"
          [ngClass]="{
            'p-invalid ng-invalid ng-dirty': inputConfig.control.touched && inputConfig.control.errors
          }">
        </p-inputSwitch>
      </div>
    </ng-container>
    <div *ngIf="inputConfig.control?.errors" class="error-message">
      <small class="p-error block" *ngIf="inputConfig.control?.touched && inputConfig.control?.errors">{{
        inputConfig.control.errors!['error'] | translate
      }}</small>
    </div>
  </div>
  <div *ngIf="!inputConfig.control">
    <ng-container>
      <div class="d-flex align-items-center justify-content-between">
        <i *ngIf="icon" class=" fal {{ icon }} align-self-center"></i>
        <ui-fh-label [containerClass]="'pt-0 switch-margin'" class="d-flex align-items-center" [labelConfig]="labelConfigs"></ui-fh-label>
        <p-inputSwitch styleClass="d-flex align-items-center {{ inputConfig.class }}" [(ngModel)]="value" (ngModelChange)="valueChanged()"> </p-inputSwitch>
      </div>
    </ng-container>
  </div>
</div>
